import { WSAlert, WSMarginProps } from "@wingspanhq/fe-component-library";
import { useModalUndergoingUpgrades } from "./ModalUndergoingUpgrades";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";

interface Props extends WSMarginProps {}

export const TAX_FILING_UPGRADES_COPY = (
  <>
    From <b>July 31 through October 1st, 2025</b>, we'll be performing important
    infrastructural upgrades to deliver improved functionality and performance
    for the upcoming 1099 filing season. During this period, we'll temporarily
    pause IRS submissions (and related functionality, including tax ID
    verifications).
  </>
);

export const AlertTaxFilingUndergoingUpgrades: React.FC<Props> = ({
  ...otherProps
}) => {
  const queryFeatureFlags = useFeatureFlags();
  const modalUndergoingUpgrades = useModalUndergoingUpgrades();

  if (queryFeatureFlags.data?.is1099FilingPaused === true) {
    return (
      <WSAlert
        theme="info"
        size="M"
        icon="info-circle"
        title={`Tax filing undergoing upgrades`}
        action={{
          onClick: () => {
            modalUndergoingUpgrades.open();
          },
          text: "Learn more"
        }}
        {...otherProps}
      >
        {TAX_FILING_UPGRADES_COPY}
      </WSAlert>
    );
  }
  return null;
};
